"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.attributesFind = exports.attributeDisplayFormRef = exports.attributeAlias = exports.attributeIdentifier = exports.attributeUri = exports.attributeLocalId = exports.idMatchAttribute = exports.anyAttribute = exports.isAttribute = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2020 GoodData Corporation
var objRef_1 = require("../../objRef");
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
/**
 * Type guard checking whether object is an instance of IAttribute.
 *
 * @public
 */
function isAttribute(obj) {
    return !isEmpty_1.default(obj) && obj.attribute !== undefined;
}
exports.isAttribute = isAttribute;
/**
 * Predicate that returns true for any attribute.
 *
 * @public
 */
exports.anyAttribute = function (_) { return true; };
/**
 * Factory function for attribute predicate which evaluates true for attributes that match particular ID.
 *
 * @public
 */
exports.idMatchAttribute = function (id) { return function (attr) {
    return attr.attribute.localIdentifier === id;
}; };
//
//
//
/**
 * Gets local identifier of an attribute. For convenience and fluency, this function accepts both attribute object and
 * identifier.
 *
 * @param attributeOrId - attribute to work with or the identifier
 * @returns value of local identifier
 * @public
 */
function attributeLocalId(attributeOrId) {
    ts_invariant_1.default(attributeOrId, "attribute must be specified");
    return typeof attributeOrId === "string" ? attributeOrId : attributeOrId.attribute.localIdentifier;
}
exports.attributeLocalId = attributeLocalId;
/**
 * Gets URI of attribute's display form to use and get attribute element values from.
 *
 * @param attribute - attribute to work with, may be undefined == result is undefined
 * @returns display form URI as string, undefined if display form not specified using URI
 * @public
 */
function attributeUri(attribute) {
    ts_invariant_1.default(attribute, "attribute must be specified");
    return objRef_1.isUriRef(attribute.attribute.displayForm) ? attribute.attribute.displayForm.uri : undefined;
}
exports.attributeUri = attributeUri;
/**
 * Gets identifier of attribute's display form to use and get attribute element values from.
 *
 * @param attribute - attribute to work with, may be undefined == result is undefined
 * @returns display form identifier as string, undefined if display for not specified using identifier
 * @public
 */
function attributeIdentifier(attribute) {
    ts_invariant_1.default(attribute, "attribute must be specified");
    return objRef_1.isIdentifierRef(attribute.attribute.displayForm)
        ? attribute.attribute.displayForm.identifier
        : undefined;
}
exports.attributeIdentifier = attributeIdentifier;
/**
 * Gets an attribute alias.
 *
 * @param attribute - attribute to work with
 * @returns value of attribute alias
 * @public
 */
function attributeAlias(attribute) {
    ts_invariant_1.default(attribute, "attribute must be specified");
    return attribute.attribute.alias;
}
exports.attributeAlias = attributeAlias;
/**
 * Gets an attribute display form object ref.
 *
 * @param attribute - attribute to work with
 * @returns value of attribute display form object ref
 * @public
 */
function attributeDisplayFormRef(attribute) {
    ts_invariant_1.default(attribute, "attribute must be specified");
    return attribute.attribute.displayForm;
}
exports.attributeDisplayFormRef = attributeDisplayFormRef;
/**
 * Given list of attributes, returns first-found attribute matching the provided predicate.
 *
 * If no predicate is provided, then the function defaults to anyAttribute predicate - meaning first found attribute
 * will be returned.
 *
 * This function also provides convenience to find attribute by its local identifier - if you pass predicate as
 * string the function will automatically create idMatchAttribute predicate.
 *
 * @param attributes - list of attributes to work with, must be specified
 * @param idOrFun - attribute identifier or instance of AttributePredicate; {@link anyAttribute} predicate is default
 * @public
 */
function attributesFind(attributes, idOrFun) {
    if (idOrFun === void 0) { idOrFun = exports.anyAttribute; }
    ts_invariant_1.default(attributes, "attributes must be specified");
    if (!attributes.length) {
        return;
    }
    var predicate = typeof idOrFun === "string" ? exports.idMatchAttribute(idOrFun) : idOrFun;
    return attributes.find(predicate);
}
exports.attributesFind = attributesFind;
//# sourceMappingURL=index.js.map